import definition from './privileges.service';

/**
 * PrivilegesApi settings
 * @type {{name: string, definition: PrivilegesApi}}
 */
export default {
    name: 'PrivilegesApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/privileges/index.js